import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks";
import { Job, JobsResponse } from "@/types";

/**
 * This hook is used to update a job in the jobs query without refetching the entire query.
 */
export const useSetJobInJobs = () => {
  const currentCompanyId = useCurrentCompanyId();
  const queryClient = useQueryClient();

  return ({ job }: { job: Job }) => {
    queryClient.setQueryData(
      ["jobs", currentCompanyId],
      (cachedData: JobsResponse[]) => {
        return cachedData.map((cachedJobResponse) => {
          if (cachedJobResponse.job.id === job.id) {
            return { ...cachedJobResponse, job };
          }
          return cachedJobResponse;
        });
      },
    );
  };
};
